module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addPicture"
  }, [_c('el-upload', {
    staticClass: "upload",
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "name": "uploadFile",
      "mutiple": false,
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.imgs
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "地址"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cdb623b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/article/addPicture.vue
// module id = 939
// module chunks = 0